module.exports = __webpack_public_path__ + "img/discount_howto1.c5970b9e.jpg";